module.exports = __webpack_public_path__ + "static/media/smiley2.79312845.png";